'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const EnterIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="EnterIcon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_355_202)">
          <path
            d="M4.5 0.496994H19.5C19.5 0.496994 23.5 0.496994 23.5 4.49699V19.497C23.5 19.497 23.5 23.497 19.5 23.497H4.5C4.5 23.497 0.5 23.497 0.5 19.497V4.49699C0.5 4.49699 0.5 0.496994 4.5 0.496994Z"
            stroke="#3D517B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.5 12.5H16.5C16.7652 12.5 17.0196 12.3946 17.2071 12.2071C17.3946 12.0196 17.5 11.7652 17.5 11.5V8.5"
            stroke="#3D517B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M9.5 9.49699L6.5 12.497L9.5 15.497" stroke="#3D517B" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
          <clipPath id="clip0_355_202">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

EnterIcon.propTypes = {
  sx: PropTypes.object
}
